document.addEventListener("DOMContentLoaded", () => {
      const countdown = document.querySelector(".sale-countdown");
      if (!countdown) return;

      const endDate = new Date(countdown.dataset.endDate).getTime();
      const d = document.getElementById("days");
      const h = document.getElementById("hours");
      const m = document.getElementById("minutes");
      const s = document.getElementById("seconds");

      const updateTimer = () => {
        const now = Date.now();
        const diff = endDate - now;

        if (diff < 0) {
          clearInterval(timer);
          countdown.innerHTML = "<span class='label'>{{ section.settings.expired_text }}</span>";
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        d.textContent = String(days).padStart(2, "0");
        h.textContent = String(hours).padStart(2, "0");
        m.textContent = String(minutes).padStart(2, "0");
        s.textContent = String(seconds).padStart(2, "0");
      };

      const timer = setInterval(updateTimer, 1000);
      updateTimer();
    });